import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = ({ onSearch, region, setRegion, regionOptions, platform, setPlatform, platformOptions, type, setType, freeOnly, setFreeOnly, onHomeReset }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [imageSearchOpen, setImageSearchOpen] = useState(false);
  const [term, setTerm] = useState('');
  
  const [regionAccordionOpen, setRegionAccordionOpen] = useState(false);
  const [regionQuery, setRegionQuery] = useState('');

  const history = useHistory();

  const filteredRegions = regionOptions.filter(r => 
    r.label.toLowerCase().includes(regionQuery.toLowerCase()) || 
    r.value.toLowerCase().includes(regionQuery.toLowerCase())
  );
  
  const currentRegionName = region === 'ALL' ? ' GLOBAL (ALL)' : regionOptions.find(r => r.value === region)?.label || region;

  return (
    <>
      <nav className="navbar">
        <div style={{display:'flex', gap:'15px'}}>
          <button className="icon-btn" onClick={() => setMenuOpen(true)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
          <button className="icon-btn" onClick={() => setSearchOpen(true)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
          <button className="icon-btn" onClick={() => setImageSearchOpen(true)} title="Visual Search">
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
             </svg>
          </button>
        </div>

        {/* --- Dynamic Font Size for Mobile --- */}
        <div style={{
            fontWeight:'900', 
            fontSize: 'clamp(1rem, 4vw, 1.4rem)', 
            letterSpacing:'2px', 
            fontFamily: "'Rajdhani', sans-serif",
            whiteSpace: 'nowrap'
        }}>
          PSN<span style={{color:'var(--primary-glow)'}}> AVATARS</span>
        </div>
        
        <div style={{width:'80px'}}></div>
      </nav>

      <AnimatePresence>
        {menuOpen && (
          <>
            <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} className="sidebar-overlay" onClick={() => setMenuOpen(false)} />
            <motion.div initial={{x:'-100%'}} animate={{x:0}} exit={{x:'-100%'}} transition={{type:'tween'}} className="sidebar-menu">
              
              <div className="sidebar-header">
                <h3>SYSTEM MENU</h3>
                <button className="icon-btn" onClick={() => setMenuOpen(false)}>✕</button>
              </div>
              
              <div className="sidebar-content">
                <button className="menu-btn" onClick={() => { 
                    if(onHomeReset) onHomeReset(); 
                    history.push('/'); 
                    setMenuOpen(false); 
                }}>
                  <span></span> HOME
                </button>

                <hr style={{borderColor:'#222', margin:'20px 0'}} />

                <span className="sidebar-label">DATABASE MODE</span>
                <div style={{display:'flex', gap:'10px', marginBottom:'20px'}}>
                   <button className={`menu-btn ${type==='avatars'?'active':''}`} style={{justifyContent:'center', margin:0}} onClick={() => setType('avatars')}>AVATARS</button>
                   
                   <button 
                     className="menu-btn" 
                     style={{justifyContent:'center', margin:0, borderColor: '#333'}} 
                     onClick={() => window.open('https://github.com/lI-Isekai-Il/PS3-Avatars-Edat', '_blank')}
                   >
                     EDATS ↗
                   </button>
                </div>

                <span className="sidebar-label">PLATFORM</span>
                <select className="sidebar-select" value={platform} onChange={(e) => setPlatform(e.target.value)}>
                   <option value="ALL">ALL PLATFORMS</option>
                   {platformOptions.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                </select>

                <span className="sidebar-label">REGION SELECT</span>
                <div className="region-accordion">
                   <div className="region-header" onClick={() => setRegionAccordionOpen(!regionAccordionOpen)}>
                      <span>{currentRegionName.substring(0,22)}</span>
                      <span>{regionAccordionOpen ? '▲' : '▼'}</span>
                   </div>
                   {regionAccordionOpen && (
                     <div className="region-body">
                        <input type="text" className="region-search-bar" placeholder="Filter..." value={regionQuery} onChange={(e) => setRegionQuery(e.target.value)} />
                        <div className={`region-item ${region==='ALL'?'selected':''}`} onClick={() => {setRegion('ALL'); setRegionAccordionOpen(false);}}>GLOBAL (ALL)</div>
                        {filteredRegions.map(r => (
                           <div key={r.value} className={`region-item ${region===r.value?'selected':''}`} onClick={() => {setRegion(r.value); setRegionAccordionOpen(false);}}>
                              {r.label}
                           </div>
                        ))}
                     </div>
                   )}
                </div>

              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {imageSearchOpen && (
        <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.9)', zIndex:4000, display:'flex', alignItems:'center', justifyContent:'center'}}>
           <div style={{background:'#111', padding:'40px', border:'1px solid var(--primary-glow)', textAlign:'center'}}>
              <h2 style={{color:'var(--primary-glow)'}}>VISUAL SEARCH</h2>
              <p>Upload functionality coming in next update.</p>
              <button className="menu-btn" style={{marginTop:'20px', justifyContent:'center'}} onClick={() => setImageSearchOpen(false)}>CLOSE</button>
           </div>
        </div>
      )}
      
      {searchOpen && (
        <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.9)', zIndex:4000, display:'flex', justifyContent:'center', paddingTop:'100px'}}>
           <div style={{width:'90%', maxWidth:'600px', position:'relative'}}>
              <input autoFocus type="text" placeholder="SEARCH DATABASE..." style={{width:'100%', padding:'20px', background:'#000', border:'1px solid #444', color:'#fff', fontSize:'1.5rem', fontFamily:'Rajdhani'}} 
                 value={term} onChange={(e) => setTerm(e.target.value)} onKeyDown={(e) => {if(e.key==='Enter'){onSearch(term); setSearchOpen(false);}}} />
              <button style={{position:'absolute', right:'20px', top:'20px', background:'none', border:'none', color:'#fff', fontSize:'1.5rem', cursor:'pointer'}} onClick={() => setSearchOpen(false)}>✕</button>
           </div>
        </div>
      )}
    </>
  );
};

export default Navbar;